"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltroAplicado = void 0;
var filtroAplicadoModule = require('./FiltroAplicado.module.scss');
var react_1 = __importStar(require("react"));
var Chip_1 = require("../Chip/Chip");
var globalMu_1 = __importDefault(require("../../globalMu"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var CoresIdentidadeMU_1 = __importDefault(require("../Cores/CoresIdentidadeMU"));
var Botao_1 = require("../Botao/Botao");
var Cores_1 = require("../Cores/Cores");
var FiltroAplicado = function (props) {
    var _a = props.id, id = _a === void 0 ? 'filtroAplicado' : _a, _b = props.titulo, titulo = _b === void 0 ? 'Filtros Aplicados:' : _b, _c = props.totalTextoPlural, totalTextoPlural = _c === void 0 ? 'Resultados Encontrados' : _c, _d = props.totalTextoSingular, totalTextoSingular = _d === void 0 ? 'Resultado Encontrado' : _d, _e = props.totalResultado, totalResultado = _e === void 0 ? 0 : _e, _f = props.exibirBotaoSalvar, exibirBotaoSalvar = _f === void 0 ? false : _f, _g = props.desabilitarFiltro, desabilitarFiltro = _g === void 0 ? false : _g, filtros = props.filtros, _h = props.exibirResultados, exibirResultados = _h === void 0 ? true : _h, _j = props.onSalvarFiltro, onSalvarFiltro = _j === void 0 ? function () { } : _j;
    var _k = (0, react_1.useState)(totalTextoSingular), textoTotal = _k[0], setTextoTotal = _k[1];
    var _l = (0, react_1.useState)(filtros), filtrosSelecionados = _l[0], setFiltrosSelecionados = _l[1];
    var configBotao = {
        estilo: "outlined",
        tamanho: "small",
        exibirBotaoArrendondado: false,
    };
    var formatarTotal = function () {
        if (totalResultado < 2) {
            return "".concat(totalResultado, " ").concat(totalTextoSingular);
        }
        else {
            return "".concat(globalMu_1.default.formatarValorNumerico(totalResultado, 0, false), " ").concat(totalTextoPlural);
        }
    };
    var handleClickSalvarFiltro = function () {
        onSalvarFiltro && onSalvarFiltro(filtrosSelecionados !== null && filtrosSelecionados !== void 0 ? filtrosSelecionados : []);
    };
    (0, react_1.useEffect)(function () {
        setTextoTotal(formatarTotal());
    }, [totalResultado]);
    var containerEsquerda = react_1.default.createElement("div", { className: "".concat(filtroAplicadoModule.filtroAplicadoColunaEsquerda) },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", cor: CoresIdentidadeMU_1.default.cinzaMu }, titulo));
    var containerCentral = react_1.default.createElement("div", { className: "".concat(filtroAplicadoModule.filtroAplicadoColunaCentral) }, filtrosSelecionados && (Array.from(filtrosSelecionados)).map(function (item) {
        var _a;
        return (react_1.default.createElement("div", { key: item.id },
            react_1.default.createElement(Chip_1.Chip, __assign({}, item, { desabilitado: desabilitarFiltro, estilo: (_a = item.estilo) !== null && _a !== void 0 ? _a : 'gray' }))));
    }));
    var containerDireitaTotal = react_1.default.createElement("div", { className: "".concat(filtroAplicadoModule.filtroAplicadoColunaDireita) },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", cor: CoresIdentidadeMU_1.default.cinzaMu }, textoTotal));
    var containerDireitaSalvar = react_1.default.createElement("div", { className: "".concat(filtroAplicadoModule.filtroAplicadoColunaDireitaBotao) },
        react_1.default.createElement(Botao_1.Botao, __assign({}, configBotao, { onClick: function () { return handleClickSalvarFiltro(); } }),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "button2", cor: Cores_1.Cores.CoresIdentidadeMU.azulMu, negrito: 700 }, "Salvar Filtro")));
    return (react_1.default.createElement("div", { id: id, className: "".concat(filtroAplicadoModule.filtroAplicadoComponent) },
        filtros && filtros.length > 0 && containerEsquerda,
        containerCentral,
        exibirBotaoSalvar ? (containerDireitaSalvar) : exibirResultados && (containerDireitaTotal)));
};
exports.FiltroAplicado = FiltroAplicado;
